import { OpenTextEditor } from '@assembly-web/ui';
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import ScrollToBottom from 'react-scroll-to-bottom';

import { useGetPlanFeaturesQuery } from '../../../hooks/useGetPlanFeaturesQuery';
import { useUserDetails } from '../../../hooks/useUserDetails';
import { isDoraIncludedInWorkspacePlan } from '../../../services/dora';
import { BottomActionSheet } from '../shared/dora/BottomActionSheet';
// import { ChatHistoryError } from '../shared/dora/ChatHistoryError';
// import { ChatHistoryLoading } from '../shared/dora/ChatHistoryLoading';
import type { FlowCreationDrawer as FlowCreationDrawerProps } from '../types';

const messages = defineMessages({
  placeholder: {
    defaultMessage: 'Ask something',
    id: 'Yh9fcS',
  },
});

export function FlowCreationChatView(props: FlowCreationDrawerProps) {
  const { title } = props;
  const { formatMessage } = useIntl();

  const { data: planFeatureDetails } = useGetPlanFeaturesQuery();

  const [value, setValue] = useState('');

  const { data: userDetails } = useUserDetails();
  if (!userDetails) {
    return;
  }
  const isDoraIncludedInPlan =
    isDoraIncludedInWorkspacePlan(planFeatureDetails);

  // TODO: Include loading/error states
  // if (isChatHistoryLoading) {
  //   return <ChatHistoryLoading />;
  // } else if (isChatHistoryError) {
  //   return <ChatHistoryError onTryAgain={() => {}} />;
  // }

  return (
    <div className="flex h-full flex-col justify-end bg-gray-1">
      <ScrollToBottom
        className="overflow-auto"
        followButtonClassName="hidden"
        initialScrollBehavior="auto"
      >
        <section className="grid grid-cols-[max-content_minmax(0,1fr)] gap-x-2 gap-y-4 overflow-auto p-6">
          {title}
        </section>
      </ScrollToBottom>
      {Boolean(isDoraIncludedInPlan) && (
        <BottomActionSheet shouldAnimateOnMount={false}>
          <div className="mx-6 my-2">
            <OpenTextEditor
              className="max-h-[174px]"
              isSubmitDisabled={value.trim() === ''}
              maxLength={500}
              onChange={(e) => setValue(e.target.value)}
              onSubmit={() => {}}
              placeholder={formatMessage(messages.placeholder)}
              rows={1}
              shouldSubmitOnEnter
              value={value}
              autoFocusInput
            />
          </div>
        </BottomActionSheet>
      )}
    </div>
  );
}
